import { useRef } from 'react'

import { StatusOverviewStatus } from '../StatusOverview.types'

import { useTextOverflow } from '@percent/utility'
import { Badge, BadgeVariant, Flex, IconRegistry, Text, Tooltip, theme } from '@percent/lemonade'
import style from './StatusCard.module.scss'
import { StatusCardProps } from './StatusCard.types'

const variantFromStatus: Record<StatusOverviewStatus, BadgeVariant> = {
  total: 'default',
  trusteeApprovalRequired: 'default',
  agentApprovalRequired: 'default',
  managerApprovalRequired: 'default',
  inTransit: 'interactive',
  paid: 'positive',
  returned: 'warning',
  failed: 'critical',
  cancelled: 'critical'
} as const

const iconFromStatus: Record<StatusOverviewStatus, keyof typeof IconRegistry> = {
  total: 'claims',
  trusteeApprovalRequired: 'clock',
  agentApprovalRequired: 'clock',
  managerApprovalRequired: 'clock',
  inTransit: 'approve',
  paid: 'approve',
  returned: 'warning',
  failed: 'reject',
  cancelled: 'reject'
} as const

export function StatusCard({ status, label, amount, count }: Readonly<StatusCardProps>) {
  const labelRef = useRef<HTMLSpanElement>(null)
  const isLabelOverflowing = useTextOverflow(labelRef)

  return (
    <Flex direction="column" className={style.card} gap={8} p={16}>
      <Tooltip content={isLabelOverflowing ? label : ''}>
        <span ref={labelRef} className={style.label}>
          <Text size="small" color={theme.scale.neutral900} fontWeight="medium">
            {label}
          </Text>
        </span>
      </Tooltip>
      <div className={style.amountRow}>
        <Text size="small" color={theme.scale.neutral700} fontWeight="medium">
          {amount}
        </Text>
        <Badge variant={variantFromStatus[status]} icon={iconFromStatus[status]} testId={status}>
          {String(count)}
        </Badge>
      </div>
    </Flex>
  )
}
